<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">凭证列表</span></div>
		<div class="margin-right-left margin-top">
			<account-date-range-choose v-model="dateRange"/>
			<div class="float-right">
				<template v-if="User.role!=='View' && currentAccountSets.voucherReviewed">
					<Button :loading="loading" @click="audit">审核</Button>
					<Button :loading="loading" @click="cancelAudit">取消审核</Button>
				</template>
				<DropdownMenu button @click="trigger" :datas="param">打印</DropdownMenu>
				<template v-if="User.role!=='View'">
					<Button :loading="loading" @click="finishingOffNo">整理断号</Button>
					<Button :loading="loading" @click="batchDelete">批量删除</Button>
					<Button :loading="loading" @click="showImportModal=true">导入凭证</Button>
				</template>
			</div>
		</div>
		<Modal v-model="showImportModal" :closeOnMask="false" :hasCloseIcon="true" :width="520">
			<div slot="header">导入凭证</div>
			<div class="voucher-import-box">
				<p class="font-bold">第一步：下载凭证导入模板</p>
				<p class="gray-color">请先下载模板，并按照模板中的表头填写凭证数据。</p>
				<a class="h-btn h-btn-primary" :href="voucherTemplateUrl">下载模板</a>
				<p class="font-bold margin-top">第二步：上传已填写的凭证文件</p>
				<p class="gray-color">支持 .xls 和 .xlsx 文件。</p>
				<Button @click="$refs.file.click()" :loading="loading">选择文件</Button>
				<span class="margin-left" v-if="importFileName">已选：{{importFileName}}</span>
				<input ref="file" type="file" accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none" @change="fileChange($event)">
			</div>
			<div class="text-center">
				<Button color="green" @click="importVoucher" :disabled="!importFileName" :loading="loading">开始导入</Button>
				<Button @click="closeImportModal" :loading="loading">取消</Button>
			</div>
		</Modal>
		<div class="h-panel-body">
			<table class="header">
				<colgroup>
					<col style="width: 50px">
					<col style="width: 215px">
					<col>
					<col style="width: 130px">
					<col style="width: 130px">
				</colgroup>
				<tr>
					<th style="width: 50px"><input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll"></th>
					<td style="width: 215px">摘要</td>
					<td>科目</td>
					<td align="right" style="width: 130px">借方金额</td>
					<td align="right" style="width: 130px">贷方金额</td>
				</tr>
			</table>
			<table v-if="!datas.length">
				<tr>
					<td colspan="5" class="text-center padding">暂无数据</td>
				</tr>
			</table>
			<table class="details" v-for="data in datas" :key="data.id">
				<colgroup>
					<col style="width: 50px">
					<col style="width: 215px">
					<col>
					<col style="width: 130px">
					<col style="width: 130px">
				</colgroup>
				<tr class="details-header">
					<th style="width: 50px"><input :class="{'display':data._checked}" v-model="data._checked" type="checkbox"></th>
					<td colspan="2">日期：{{data.voucherDate}} 凭证字号：{{data.word}}-{{data.code}}</td>
					<td colspan="2" class="actions" align="right">
						<router-link v-if="data.auditMemberId" :to="{name:'VoucherForm',params:{voucherId:data.id}}"><span>查看</span></router-link>
						<a :href="`/api/pfd/voucher?id=${data.id}`" target="_blank">打印</a>
						<router-link v-if="User.role!=='View'" :to="{name:'VoucherForm',params:{voucherId:data.id}}"><span>修改</span></router-link>
						<span v-if="User.role!=='View'" @click="remove(data)">删除</span>
						<i v-if="data.auditMemberId" class="h-icon-completed green-color" v-tooltip content="已审核"></i>
					</td>
				</tr>
				<tr v-for="d in data.details" :key="d.id">
					<th></th>
					<td style="width: 215px">
						{{d.summary}}
						<template v-if="d.subject&&d.num&&d.price">
							(数量:{{d.num}}<span class="dark4-color">{{d.subject.unit}}</span>，单价:{{d.price}}<span class="dark4-color">元</span>)
						</template>
					</td>
					<td>{{d.subjectName}}</td>
					<td align="right" style="width: 130px">{{d.debitAmount|numFormat}}</td>
					<td align="right" style="width: 130px">{{d.creditAmount|numFormat}}</td>
				</tr>
				<tr class="font-bold">
					<td></td>
					<td>合计</td>
					<td>{{data.debitAmount|dxMoney}}</td>
					<td align="right">{{data.debitAmount|numFormat}}</td>
					<td align="right">{{data.creditAmount|numFormat}}</td>
				</tr>
			</table>
			<!-- 区间合计 -->
			<table class="range-summary" v-if="datas.length > 0 && rangeSummary">
				<colgroup>
					<col style="width: 50px">
					<col style="width: 215px">
					<col>
					<col style="width: 130px">
					<col style="width: 130px">
				</colgroup>
				<tr class="font-bold">
					<td style="width: 50px"></td>
					<td style="width: 215px">区间合计</td>
					<td>共 {{rangeSummary.totalCount}} 张凭证</td>
					<td align="right" style="width: 130px">{{rangeSummary.totalDebitAmount|numFormat}}</td>
					<td align="right" style="width: 130px">{{rangeSummary.totalCreditAmount|numFormat}}</td>
				</tr>
			</table>
			<Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
		</div>
	</app-content>
</template>

<script>
	import Qs from "qs";
	import moment from 'moment'
	import {mapState} from 'vuex'
	import AccountDateRangeChoose from '@/components/AccountDateRangeChoose.vue';

	export default {
		name: "Voucher",
		components: {AccountDateRangeChoose},
		data() {
			return {
				datas: [],
				dateRange: null,
				pagination: {
					page: 1,
					total: 0
				},
				loading: false,
				checkAll: false,
				param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}],
				rangeSummary: null,
				showImportModal: false,
				importFile: null
			};
		},
		watch: {
			checkAll(nval) {
				let data = Array.from(this.datas);
				data.forEach(val => val._checked = nval);
				this.datas = data;
			},
			dateRange: {
				handler(val) {
					if (val && val.startDate && val.endDate) {
						this.pagination.page = 1;
						this.loadList();
						this.loadRangeSummary();
					}
				},
				deep: true
			}
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			voucherTemplateUrl() {
				return '/api/voucher/template';
			},
			importFileName() {
				return this.importFile ? this.importFile.name : '';
			}
		},
		methods: {
			currentChange() {
				this.loadList();
			},
			trigger(key) {
				this[key].call(this);
			},
			printAll() {
				if (!this.dateRange) return;
				let param = Qs.stringify({
					year: this.dateRange.endYear,
					month: this.dateRange.endMonth
				}, {indices: false});
				window.open(`/api/pfd/voucher?${param}`);
			},
			printCheck() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
					window.open(`/api/pfd/voucher?${param}`);
				} else {
					this.$Message("未选择记录");
				}
			},
			loadList() {
				if (!this.dateRange) return;
				this.$api.voucher.list({
					startYear: this.dateRange.startYear,
					startMonth: this.dateRange.startMonth,
					endYear: this.dateRange.endYear,
					endMonth: this.dateRange.endMonth,
					page: this.pagination.page
				}).then(({data}) => {
					this.datas = data.records;
					this.pagination = {
						page: data.current,
						size: data.size,
						total: data.total
					}
				})
			},
			loadRangeSummary() {
				if (!this.dateRange) return;
				this.$api.voucher.summaryByRange({
					startYear: this.dateRange.startYear,
					startMonth: this.dateRange.startMonth,
					endYear: this.dateRange.endYear,
					endMonth: this.dateRange.endMonth
				}).then(({data}) => {
					this.rangeSummary = data;
				});
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.voucher.delete(data.id).then(() => {
						this.loadList();
						this.loadRangeSummary();
					})
				});
			},
			finishingOffNo() {
				if (!this.dateRange) return;
				this.loading = true;
				this.$api.voucher.finishingOffNo({
					year: this.dateRange.endYear,
					month: this.dateRange.endMonth
				}).then(() => {
					this.loadList();
				}).finally(() => {
					this.loading = false
				});
			},
			batchDelete() {
				if (!this.dateRange) return;
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("确认删除?").then(() => {
						this.loading = true;
						this.$api.voucher.batchDelete({
							checked: checked.map(value => value.id),
							year: this.dateRange.endYear,
							month: this.dateRange.endMonth
						}).then(() => {
							this.loadList();
							this.loadRangeSummary();
						}).finally(() => {
							this.loading = false
						});
					});
				}
			},
			audit() {
				if (!this.dateRange) return;
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要审核吗?").then(() => {
						this.loading = true;
						this.$api.voucher.audit({
							checked: checked.map(value => value.id),
							year: this.dateRange.endYear,
							month: this.dateRange.endMonth
						}).then(() => {
							this.loadList();
							this.$Message("审核成功！");
						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			cancelAudit() {
				if (!this.dateRange) return;
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要取消审核吗?").then(() => {
						this.loading = true;
						this.$api.voucher.cancelAudit({
							checked: checked.map(value => value.id),
							year: this.dateRange.endYear,
							month: this.dateRange.endMonth
						}).then(() => {
							this.loadList();
							this.$Message("取消审核成功！");
						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			fileChange() {
				this.importFile = this.$refs.file.files[0] || null;
			},
			importVoucher() {
				if (!this.importFile) return;
				let formData = new FormData();
				formData.append('file', this.importFile);
				this.loading = true;
				this.$api.voucher.import(formData).then(() => {
					this.$store.dispatch('init');
					this.$Message("亲,导入成功~");
					this.closeImportModal();
					this.loadList();
					this.loadRangeSummary();
				}).finally(() => {
					this.loading = false;
				});
			},
			closeImportModal() {
				this.showImportModal = false;
				this.importFile = null;
				if (this.$refs.file) {
					this.$refs.file.value = "";
				}
			}
		}
	};
</script>
<style lang='less' scoped>
	.voucher-import-box {
		padding: 10px 20px 20px;
		line-height: 28px;
	}

	.h-panel-body {
		table {
			width: 100%;
			table-layout: fixed;
			border-collapse: collapse;

			td, th {
				word-break: break-all;
			}

			td {
				padding: 7px;
			}

			&.header {
				background-color: @primary-color;
				color: white;
			}
		}

		.details {
			font-size: 12px;
			margin: 15px 0;
			border: 1px solid @gray2-color;

			.actions {
				text-align: right;
				padding-right: 20px;

				span, a {
					display: none;
				}
			}

			input {
				display: none;

				&.display {
					display: inline-block;
				}
			}

			&-header {
				background-color: @gray3-color;
				color: @dark3-color;
			}

			td, th {
				border-bottom: 1px solid @gray2-color;
			}

			tr:hover:not(.details-header) {
				background-color: #dff7df;
				cursor: pointer;
			}

			&:hover {
				box-shadow: 0 0 10px 0 #dadada;
				border-color: #dadada;

				.actions {
					span, a {
						display: inline-block;
					}
				}

				input {
					display: inline-block;
				}
			}
		}

		.range-summary {
			font-size: 12px;
			border: 1px solid @primary-color;
			background-color: #e8f4ff;
			
			td {
				padding: 10px 7px;
			}
		}
	}
</style>